// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright_copyright__2_DYf","copyrightText":"Copyright_copyrightText__2jh_Z","copyrightIcon":"Copyright_copyrightIcon__B_5J2"};